/**
 * Created by Pierrot on 08/10/2014.
 */
'use strict';
import * as _ from 'lodash';

module.exports = function (angular) {



    return {
        hours: function () {
            return function (value) {
                const h = parseInt(value);
                const m = (value - h)*60;
                return _.padStart(h,2,'0')+"h"+_.padStart(m,2,'0');
            }
        }
    };
};